// extracted by mini-css-extract-plugin
export var aligncenter = "NotFound-module--aligncenter--55281";
export var alignright = "NotFound-module--alignright--8778c";
export var notFound = "NotFound-module--not-found--7c5d6";
export var notFoundButton = "NotFound-module--not-found-button--74dc4";
export var wpBlockJetpackGif = "NotFound-module--wp-block-jetpack-gif--bbf59";
export var wpBlockJetpackGifWrapper = "NotFound-module--wp-block-jetpack-gif-wrapper--22e4b";